import { RouterReducerState } from '@ngrx/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  ADD_MODE_PARAM,
  EDIT_MODE_PARAM,
  FIND_MODE_PARAM,
  MODAL_LIST_MODE_PARAM,
  VIEW_MODE_PARAM,
} from '../constants';
import { RouterStateUrl } from '../router.interfaces';

export const selectRouterState =
  createFeatureSelector<RouterReducerState<RouterStateUrl>>('router');

export const getRouterInfo = createSelector(
  selectRouterState,
  (state) => state?.state
);

export const selectQueryParams = createSelector(
  getRouterInfo,
  (r) => r.queryParams
);

export const channelId = createSelector(
  selectQueryParams,
  (params) =>
    (params[ADD_MODE_PARAM] ||
      params[VIEW_MODE_PARAM] ||
      params[FIND_MODE_PARAM] ||
      params[EDIT_MODE_PARAM] ||
      params[MODAL_LIST_MODE_PARAM]) as string | undefined
);

export const isViewOnlyMode = createSelector(
  selectQueryParams,
  (params) => !!params[VIEW_MODE_PARAM]
);

export const isFindMode = createSelector(
  selectQueryParams,
  (params) => !!params[FIND_MODE_PARAM]
);

export const isAddMode = createSelector(
  selectQueryParams,
  (params) => !!params[ADD_MODE_PARAM]
);

export const isEditMode = createSelector(
  selectQueryParams,
  (params) => !!params[EDIT_MODE_PARAM]
);

export const isModalListMode = createSelector(
  selectQueryParams,
  (params) => !!params[MODAL_LIST_MODE_PARAM]
);
